import { render, staticRenderFns } from "./RedeemRewards.vue?vue&type=template&id=c0cc6e9a&scoped=true"
import script from "./RedeemRewards.vue?vue&type=script&lang=js"
export * from "./RedeemRewards.vue?vue&type=script&lang=js"
import style0 from "./RedeemRewards.vue?vue&type=style&index=0&id=c0cc6e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc6e9a",
  null
  
)

export default component.exports